export default "__VITE_ASSET__BNt_XX8E__"